export default defineNuxtPlugin(() => {
  const route = useRoute()
  const analytics = useAnalytics()

  if (process.client && route.query.status === 'failed' && route.query.orderUuid) {
    analytics.analyticsLayer({'event': 'trans_form_step7_x'})
  }
})